import { Box } from "@mui/material";

import { ReactComponent as PerfeitoIcon } from "../../../assets/images/ic-perfeitos.svg";
import { ReactComponent as ImperfeitoIcon } from "../../../assets/images/ic-imperfeitos.svg";
import { ReactComponent as PhantonIcon } from "../../../assets/images/ic-phanton.svg";

interface BomTypeCellProps {
  is_phantom?: boolean;
  is_imperfect?: boolean;
}

const iconStyle = { width: 16, height: 16, flexShrink: 0 };

/**
 * Renders the "Tipo" column cell used in BOM listings: a perfect/imperfect
 * indicator plus an optional phantom indicator. Shared between the general
 * BOM listing (`BOMComponentComponent`) and the BOM substitution simulation tab.
 */
const BomTypeCell = ({ is_phantom, is_imperfect }: BomTypeCellProps) => (
  <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: "100%", gap: "6px" }}>
    {is_imperfect ? <ImperfeitoIcon style={iconStyle} /> : <PerfeitoIcon style={iconStyle} />}
    {is_phantom
      ? <PhantonIcon style={iconStyle} />
      : <span style={{ width: 16, height: 16, display: "inline-block", flexShrink: 0 }} />}
  </Box>
);

export default BomTypeCell;
